import { render, staticRenderFns } from "./new-facility-dialog.vue?vue&type=template&id=fc3bdce0&"
import script from "./new-facility-dialog.vue?vue&type=script&lang=js&"
export * from "./new-facility-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports